import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import classnames from 'classnames';
import withStyles from '../../../../utils/withStyles';
import styles from './styles';


const SecondaryButton = ({
  classes, className, onClick, children, type,
}) => (
  <Button className={classnames(classes.button, className)} onClick={onClick} type={type}>
    {children}
  </Button>
);

SecondaryButton.defaultProps = {
  className: null,
  type: 'button',
};

SecondaryButton.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
};

export default withStyles(styles)(SecondaryButton);
